import { Box } from "@mui/material";
import ShLabel from "../../../theme/label/ShLabel";
import ShLabelSkeleton from "../../../theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";
import Text from "../../../theme/text/Text";
import { getReturnStateData } from "../../../../utils/labelColorText";
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import BackHandOutlinedIcon from '@mui/icons-material/BackHandOutlined';
import { return_type } from "../../../../utils/staticEnums";
import { RelationReturnCard } from "../../cards/inbounds/ReturnCards";
import { ReactComponent as BolLogo } from '../../../../styles/svg/bol.svg';

export const rhReturnColumns =  (i18n,theme,t,colors,columnStrategy) => {
    
    return [
        {field: "order", headerName: t("order"),flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Box
                        sx={{
                            display:'flex',
                            alignItems:"center",
                            gap:1.5,
                        }}
                    >
                        {params.row.type === return_type.RETURNPORTAL &&
                            <Box
                                sx={{
                                    flexShrink:0,
                                    width:32,
                                    height:32,
                                    background: colors.orange[100],
                                    borderRadius:4,
                                    display:"flex",
                                    alignItems:'center',
                                    justifyContent:'center',
                                    border: `1px solid ${colors.orange[400]}`,
                                    color: colors.orange[400],
                                }}
                            >
                                <StorefrontOutlinedIcon fontSize="small"/>
                            </Box>
                        }
                        {params.row.type === return_type.BOL &&
                            <Box
                                sx={{
                                    flexShrink:0,
                                    width:32,
                                    height:32,
                                    background:"#E5E5F5",
                                    borderRadius:4,
                                    display:"flex",
                                    alignItems:'center',
                                    justifyContent:'center',
                                    border: '1px solid #000099',
                                }}
                            >
                                <BolLogo width={20}/>
                            </Box>
                        }
                        {(!params.row.type || params.row.type === return_type.DEFAULT) &&
                            <Box
                                sx={{
                                    flexShrink:0,
                                    width:32,
                                    height:32,
                                    background:colors.grey[100],
                                    borderRadius:4,
                                    display:"flex",
                                    alignItems:'center',
                                    justifyContent:'center',
                                    border: `1px solid ${colors.txt["primary"]}`,
                                    color:colors.txt["primary"],
                                    "& svg": {
                                        transform:'rotate(45deg)',
                                    }
                                }}
                            >
                                <BackHandOutlinedIcon fontSize="small"/>
                            </Box>
                        }
                        <Box
                            sx={{
                                width:1,
                                display:'flex',
                                flexDirection:"column",
                            }}
                        >
                            <Text>{params.row.order?.barcode ? "R" +params.row.order?.barcode : t("imported")}</Text>
                            <Text fontSize={13} light italic>{params.row.webshopreference}</Text>

                        </Box>
                    </Box>
                );
            }
        },
        {field: "relation", headerName: t("relation"),flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return( 
                    <Box
                        sx={{
                            width:1,
                            display:'flex',
                            flexDirection:"column",
                        }}
                    >
                        <Text>{params.row.relation?.name}</Text>
                        <Text fontSize={13} light italic>{params.row.order?.webshopcredentials?.description}</Text>

                    </Box>
                    
                )
            }
        },
        // {field: "lineCount", headerName: t("sku_count"),flex:1,
        //     sortable:false,
        //     renderCell: (params) => {
        //         if(params.row.skeleton) {
        //             return <ShTextSkeleton/>
        //         }
        //         return params.row.lineCount;
        //     }
        // },        

        // {field: "productCount", headerName: t("items"),flex:1,
        //     sortable:false,
        //     renderCell: (params) => {
        //         if(params.row.skeleton) {
        //             return <ShTextSkeleton/>
        //         }
        //         return params.row.productCount;
        //     }
        // },
        {
            field: "state", 
            headerName: t("status"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                const { labelcolor, labeltext } = getReturnStateData(params.row.state, theme);
              
                return (
                    <ShLabel size={32} palette="normal" variant={labelcolor}>
                      {t(labeltext)}
                    </ShLabel>
                  );
              }
        },
        {
            field: "createdAt", 
            headerName: t("created_at"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                let date = new Date(params.row.createdAt);
              
                return (
                    <Box>
                        <Text semibold>
                            {date.toLocaleDateString(i18n.language)}
                        </Text><br/>
                        <Text light>
                            {date.toLocaleTimeString(i18n.language,{timeStyle: 'short'})}
                        </Text>
                    </Box>
                );
            }
        },
        {
            field: "updatedAt", 
            headerName: t("last_updated"),
            flex:1,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                if(params.row.updatedAt === params.row.createdAt || !params.row.order?.barcode){
                    return <Text light></Text>
                }

                let date = new Date(params.row.updatedAt);
              
                return (
                    <Box>
                        <Text semibold>
                            {date.toLocaleDateString(i18n.language)}
                        </Text><br/>
                        <Text light>
                            {date.toLocaleTimeString(i18n.language,{timeStyle: 'short'})}
                        </Text>
                    </Box>
                );
            }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <RelationReturnCard 
                    // onClick={() => getReturnDetails(params)} 
                    skeleton={params.row.skeleton ?? false} {...params.row}/>
                )
            }
        }
    ]
};